import { MACRO_INPUT_SELF_TEST_RECIPE, type MacroInputSelfTestSample } from './inputSelfTestRecipe';

export const MACRO_INPUT_TRIGGER_TEST_INTERVAL_US = 100_000;

/** The immutable asymmetric binary tile rendered by MacroSimInputVisualizer; animated panels are outside this ROI. */
export const MACRO_INPUT_TRIGGER_TEST_PATTERN = Object.freeze({
  rect: Object.freeze({ x: 0, y: 0, width: 96, height: 96 }),
  recognitionRect: Object.freeze({ x: 0, y: 0, width: 96, height: 96 }),
  cellSize: 12,
  // Bits run left-to-right from bit 7. Nonperiodic rows avoid the checker's unstable near-zero DCT coefficients.
  rows: Object.freeze([0xe7, 0x81, 0xb9, 0x95, 0xe3, 0x26, 0x7c, 0x58]),
  evenRgb: 0xd1f5e8,
  oddRgb: 0x159777,
});

/** Artificial macro source events only. Physical delivery requires a fresh independently observed native run. */
export const MACRO_INPUT_TRIGGER_TEST_RECIPE: readonly MacroInputSelfTestSample[] = Object.freeze(
  MACRO_INPUT_SELF_TEST_RECIPE.map((sample, index) => Object.freeze({
    ...sample, tUs: (index + 1) * MACRO_INPUT_TRIGGER_TEST_INTERVAL_US,
  })),
);

// Retain one full input interval after the final release for native completion and receiver observation.
export const MACRO_INPUT_TRIGGER_TEST_DURATION_US = (MACRO_INPUT_TRIGGER_TEST_RECIPE.length + 1)
  * MACRO_INPUT_TRIGGER_TEST_INTERVAL_US;
